import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import PageTitle from '../components/PageTitle';
import { useCart } from '../context/CartContext';

export default function ShopCart() {
  const { cartItems, removeFromCart, updateQty, cartTotal } = useCart();
  const shipping = cartTotal > 0 ? 0 : 0; // free shipping
  const tax = +(cartTotal * 0.08).toFixed(2);

  return (
    <div className="page-wrapper">
      <Preloader />
      <Header />
      <PageTitle title="Shopping Cart" breadcrumbs={[{ label: 'Shop', path: '/shop' }, { label: 'Cart' }]} />

      <section className="cart-section pt-80 pb-80">
        <div className="auto-container">
          {cartItems.length === 0 ? (
            <div className="empty-cart">
              <i className="fas fa-cart-shopping empty-cart-icon"></i>
              <h3>Your cart is empty</h3>
              <p>Looks like you haven't added anything yet. Browse our rooms and products.</p>
              <div className="d-flex gap-3 justify-content-center mt-3">
                <Link to="/rooms" className="theme-btn btn-style-one"><span className="btn-title">Browse Rooms</span></Link>
                <Link to="/shop"  className="theme-btn btn-style-one"><span className="btn-title">Browse Shop</span></Link>
              </div>
            </div>
          ) : (
            <div className="row">
              {/* Cart Table */}
              <div className="col-lg-8">
                <div className="cart-table-wrap">
                  <table className="cart-table">
                    <thead>
                      <tr>
                        <th colSpan="2">Item</th>
                        <th>Type</th>
                        <th>Price</th>
                        <th>Qty</th>
                        <th>Subtotal</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartItems.map((item) => (
                        <tr key={`${item.id}-${item.type}`}>
                          <td className="cart-img-td">
                            <img src={item.img} alt={item.title} />
                          </td>
                          <td className="cart-name-td">
                            <strong>{item.title}</strong>
                          </td>
                          <td>
                            <span className={`cart-type-tag ${item.type}`}>
                              {item.type === 'room' ? <><i className="fas fa-bed"></i> Room</> : <><i className="fas fa-box"></i> Product</>}
                            </span>
                          </td>
                          <td>${item.price.toFixed(2)}</td>
                          <td>
                            <div className="qty-control">
                              <button onClick={() => updateQty(item.id, item.type, item.qty - 1)}>
                                <i className="fas fa-minus"></i>
                              </button>
                              <span>{item.qty}</span>
                              <button onClick={() => updateQty(item.id, item.type, item.qty + 1)}>
                                <i className="fas fa-plus"></i>
                              </button>
                            </div>
                          </td>
                          <td><strong>${(item.price * item.qty).toFixed(2)}</strong></td>
                          <td>
                            <button
                              className="cart-remove-btn"
                              onClick={() => removeFromCart(item.id, item.type)}
                              aria-label="Remove"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="cart-actions">
                  <Link to="/rooms" className="theme-btn btn-style-four">
                    <span className="btn-title"><i className="fas fa-arrow-left me-2"></i>Continue Browsing</span>
                  </Link>
                </div>
              </div>

              {/* Order Summary */}
              <div className="col-lg-4">
                <div className="cart-summary">
                  <h4 className="cart-summary-title">Order Summary</h4>
                  <ul className="summary-list">
                    <li><span>Subtotal</span><span>${cartTotal.toFixed(2)}</span></li>
                    <li><span>Shipping</span><span className="text-success">Free</span></li>
                    <li><span>Tax (8%)</span><span>${tax.toFixed(2)}</span></li>
                  </ul>
                  <div className="summary-total">
                    <span>Total</span>
                    <span>${(cartTotal + tax).toFixed(2)}</span>
                  </div>
                  <Link to="/checkout" className="theme-btn btn-style-one w-100 d-block text-center mt-4">
                    <span className="btn-title">Proceed to Checkout</span>
                  </Link>
                  <div className="cart-secure-note">
                    <i className="fas fa-lock"></i> Secure Checkout — SSL Encrypted
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
